export interface BeoordelingStatus {
  key: string;
  value: string;
  icon: string;
  description?: string;
}

export const BEOORDELING_STATUSES: BeoordelingStatus[] = [
  { key: 'nog_niet_beoordeeld', value: 'Niet beoordeeld', icon: 'priority_high', description: 'Nog niet beoordeeld. Geef aan of uw organisatie een belang heeft bij dit plan' },
  { key: 'wel_belang', value: 'Wij hebben een belang', icon: 'star', description: 'U heeft aangegeven een belang te hebben bij dit plan' },
  { key: 'geen_belang', value: 'Wij hebben geen belang', icon: 'star', description: 'U heeft aangegeven geen belang te hebben bij dit plan' },
  { key: 'mogelijk_belang', value: 'Wij hebben mogelijk een belang', icon: 'question_mark', description: 'U heeft aangegeven mogelijk een belang te hebben bij dit plan' },
];

export function getBeoordelingStatusLabel(key?: string): string {
  return (
    BEOORDELING_STATUSES.find((s) => s.key === key)?.value ?? 'Onbekende status'
  );
}

export function getBeoordelingStatusIcon(key?: string): string {
  return (
    BEOORDELING_STATUSES.find((s) => s.key === key)?.icon ?? 'priority_high'
  );
}

export function getBeoordelingStatusDescription(key?: string): string {
  return (
    BEOORDELING_STATUSES.find((s) => s.key === key)?.description ?? ''
  );
}
